import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=5b8f69c4&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"
import style0 from "./exchange.vue?vue&type=style&index=0&id=5b8f69c4&lang=scss&scoped=true"
import style1 from "./exchange.vue?vue&type=style&index=1&id=5b8f69c4&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f69c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8f69c4')) {
      api.createRecord('5b8f69c4', component.options)
    } else {
      api.reload('5b8f69c4', component.options)
    }
    module.hot.accept("./exchange.vue?vue&type=template&id=5b8f69c4&scoped=true", function () {
      api.rerender('5b8f69c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/equipment/exchange.vue"
export default component.exports